if (!customElements.get('custom-shop-process-carousel')) {
  class CustomShopProcessCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.buttons = Array.from(this.querySelectorAll('[data-step-button]'));
      this.current = this.querySelector('[data-current]');
      this.progress = this.querySelector('[data-progress]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.index = 0;
      this.autoplayDelay = Number(this.dataset.autoplay || 0);

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.select(index, true));
        button.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
      this.previous.addEventListener('click', () => this.select(this.index - 1, true));
      this.next.addEventListener('click', () => this.select(this.index + 1, true));
      this.track.addEventListener('scroll', () => this.handleScroll(), { passive: true });
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
      this.startAutoplay();
    }

    select(index, shouldScroll) {
      this.index = (index + this.buttons.length) % this.buttons.length;
      this.buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === this.index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });
      this.current.textContent = this.index + 1;
      this.progress.style.width = `${((this.index + 1) / this.buttons.length) * 100}%`;
      if (shouldScroll) this.buttons[this.index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    handleKeydown(event, index) {
      let target = null;
      if (event.key === 'ArrowRight') target = index + 1;
      if (event.key === 'ArrowLeft') target = index - 1;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = this.buttons.length - 1;
      if (target === null) return;
      event.preventDefault();
      this.select(target, true);
      this.buttons[this.index].focus();
    }

    handleScroll() {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => {
        const trackCenter = this.track.getBoundingClientRect().left + (this.track.clientWidth / 2);
        let nearestIndex = this.index;
        let nearestDistance = Infinity;
        this.buttons.forEach((button, index) => {
          const bounds = button.getBoundingClientRect();
          const distance = Math.abs((bounds.left + (bounds.width / 2)) - trackCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        if (nearestIndex !== this.index) this.select(nearestIndex, false);
      }, 80);
    }

    startAutoplay() {
      if (!this.autoplayDelay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.select(this.index + 1, true), this.autoplayDelay);
    }

    stopAutoplay() { if (this.timer) window.clearInterval(this.timer); }
    disconnectedCallback() { this.stopAutoplay(); window.clearTimeout(this.scrollTimer); }
  }
  customElements.define('custom-shop-process-carousel', CustomShopProcessCarousel);
}
